import { render, staticRenderFns } from "./PhoneController.vue?vue&type=template&id=660b16f4&"
import script from "./PhoneController.vue?vue&type=script&lang=js&"
export * from "./PhoneController.vue?vue&type=script&lang=js&"
import style0 from "./PhoneController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports